import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import api from '../../api/api'
import { api_url } from '../../utils/utils'
import axios from 'axios'
import { paginationTotal } from '../../utils/pagination'

// =======================
// GET SETTINGS
// =======================
export const get_cashback_settings = createAsyncThunk(
    'cashback/get_cashback_settings',
    async (_, { rejectWithValue, fulfillWithValue,getState }) => {
        //  const token = getState().auth.token
        // const config = { headers: { 'Authorization': `Bearer ${token}` } }
        try {
            const { data } = await axios.get(`${api_url}/api/admin/cashback/settings`, {withCredentials: true} /*config*/)
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(
                error.response?.data || { error: 'Cashback ayarları gətirilə bilmədi' }
            )
        }
    }
)

// =======================
// UPDATE SETTINGS
// =======================
export const update_cashback_settings = createAsyncThunk(
    'cashback/update_cashback_settings',
    async (payload, { rejectWithValue, fulfillWithValue, getState }) => {
        // const token = getState().auth.token
        // const config = { headers: { 'Authorization': `Bearer ${token}` } }
        try {
            // ✅ Bütün ayarları ötür (defaultRate/tiers/isEnabled + maliyyə təhlükəsizliyi sahələri)
            const { data } = await api.put(`/admin/cashback/settings`, payload, {withCredentials: true} /*config*/)
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(
                error.response?.data || { error: 'Cashback ayarları yenilənə bilmədi' }
            )
        }
    }
)

// =======================
// GET CUSTOMERS
// =======================
export const get_cashback_customers = createAsyncThunk(
    'cashback/get_cashback_customers',
    async ({ page = 1, limit = 10, search = '' }, { rejectWithValue, fulfillWithValue, getState }) => {
        // const token = getState().auth.token
        // const config = { headers: { 'Authorization': `Bearer ${token}` } }
        try {
            const params = new URLSearchParams({ page, limit, search: search || '' })
            const { data } = await axios.get(`${api_url}/api/admin/cashback/customers?${params.toString()}`, {withCredentials: true} /*config*/)
                
        
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(
                error.response?.data || { error: 'Cashback müştəriləri gətirilə bilmədi' }
            )
        }
    }
)

// =======================
// ADD PROMO
// =======================
export const add_cashback_promo = createAsyncThunk(
    'cashback/add_cashback_promo',
    async (promoForm, { rejectWithValue, fulfillWithValue, getState }) => {
        // const token = getState().auth.token
        // const config = { headers: { 'Authorization': `Bearer ${token}` } }
        try {
            const { data } = await api.post(`/admin/cashback/promo`, promoForm, {withCredentials: true} /*config*/)
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(
                error.response?.data || { error: 'Kampaniya əlavə edilə bilmədi' }
            )
        }
    }
)

// =======================
// TOGGLE PROMO
// =======================
export const toggle_cashback_promo = createAsyncThunk(
    'cashback/toggle_cashback_promo',
    async (promoId, { rejectWithValue, fulfillWithValue, getState }) => {
        // const token = getState().auth.token
        // const config = { headers: { 'Authorization': `Bearer ${token}` } }
        try {
            const { data } = await api.put(`/admin/cashback/promo/${promoId}/toggle`, null, {withCredentials: true} /*config*/)
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(
                error.response?.data || { error: 'Kampaniya statusu dəyişdirilə bilmədi' }
            )
        }
    }
)

// =======================
// DELETE PROMO
// =======================
export const delete_cashback_promo = createAsyncThunk(
    'cashback/delete_cashback_promo',
    async (promoId, { rejectWithValue, fulfillWithValue, getState }) => {
        // const token = getState().auth.token
        // const config = { headers: { 'Authorization': `Bearer ${token}` } }
        try {
            const { data } = await api.delete(`/admin/cashback/promo/${promoId}`, {withCredentials: true} /*config*/)
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(
                error.response?.data || { error: 'Kampaniya silinə bilmədi' }
            )
        }
    }
)

const TIER_DEFAULTS = [
    { name: 'Standart', minOrders: 0, rate: 2 },
    { name: 'Silver', minOrders: 20, rate: 4 },
    { name: 'Gold', minOrders: 50, rate: 6 },
    { name: 'VIP', minOrders: 100, rate: 10 }
]

export const cashbackReducer = createSlice({
    name: 'cashback',
    initialState: {
        loader: false,
        successMessage: '',
        errorMessage: '',

        settings: null,
        tiers: TIER_DEFAULTS,
        defaultRate: 2,
        isEnabled: true,
        promos: [],

        customers: [],
        totalCustomers: 0
    },
    reducers: {
        messageClear: (state) => {
            state.successMessage = ''
            state.errorMessage = ''
        }
    },
    extraReducers: (builder) => {
        builder

            // GET SETTINGS
            .addCase(get_cashback_settings.pending, (state) => {
                state.loader = true
            })
            .addCase(get_cashback_settings.fulfilled, (state, { payload }) => {
                state.loader = false

                const s = payload.settings || {}
                state.settings = s
                state.tiers = s.tiers?.length ? s.tiers : TIER_DEFAULTS
                state.defaultRate = s.defaultRate ?? 2
                state.isEnabled = s.isEnabled ?? true
                state.promos = s.promos || []
            })
            .addCase(get_cashback_settings.rejected, (state, { payload }) => {
                state.loader = false
                state.errorMessage = payload?.error || 'Cashback ayarları gətirilmədi'
            })

            // UPDATE SETTINGS
            .addCase(update_cashback_settings.pending, (state) => {
                state.loader = true
            })
            .addCase(update_cashback_settings.fulfilled, (state, { payload }) => {
                state.loader = false
                state.successMessage = payload?.message || 'Ayarlar yadda saxlanıldı'
            })
            .addCase(update_cashback_settings.rejected, (state, { payload }) => {
                state.loader = false
                state.errorMessage = payload?.error || 'Ayarlar yenilənmədi'
            })

            // GET CUSTOMERS
            .addCase(get_cashback_customers.pending, (state) => {
                state.loader = true
            })
            .addCase(get_cashback_customers.fulfilled, (state, { payload }) => {
                state.loader = false
                state.customers = payload.customers || payload.data || []
                state.totalCustomers = paginationTotal(payload, 'total')
            })
            .addCase(get_cashback_customers.rejected, (state, { payload }) => {
                state.loader = false
                state.errorMessage = payload?.error || 'Müştərilər gətirilmədi'
            })

            // ADD PROMO
            .addCase(add_cashback_promo.pending, (state) => {
                state.loader = true
            })
            .addCase(add_cashback_promo.fulfilled, (state, { payload }) => {
                state.loader = false
                state.successMessage = payload?.message || 'Kampaniya əlavə edildi'
            })
            .addCase(add_cashback_promo.rejected, (state, { payload }) => {
                state.loader = false
                state.errorMessage = payload?.error || 'Kampaniya əlavə edilmədi'
            })

            // TOGGLE PROMO
            .addCase(toggle_cashback_promo.pending, (state) => {
                state.loader = true
            })
            .addCase(toggle_cashback_promo.fulfilled, (state, { payload }) => {
                state.loader = false
                state.successMessage = payload?.message || 'Kampaniya statusu dəyişdirildi'
            })
            .addCase(toggle_cashback_promo.rejected, (state, { payload }) => {
                state.loader = false
                state.errorMessage = payload?.error || 'Kampaniya statusu dəyişmədi'
            })

            // DELETE PROMO
            .addCase(delete_cashback_promo.pending, (state) => {
                state.loader = true
            })
            .addCase(delete_cashback_promo.fulfilled, (state, { payload }) => {
                state.loader = false
                state.successMessage = payload?.message || 'Kampaniya silindi'
            })
            .addCase(delete_cashback_promo.rejected, (state, { payload }) => {
                state.loader = false
                state.errorMessage = payload?.error || 'Kampaniya silinmədi'
            })
    }
})

export const { messageClear } = cashbackReducer.actions
export default cashbackReducer.reducer
